var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"miniview"},[_c('div',{staticClass:"loading-spacer"}),_vm._v(" "),_c('vue-loading',{attrs:{"type":"spiningDubbles","color":"#4169e1","size":{ width: '20%' }}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fcded8e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Organisms/MiniLoading.vue
// module id = null
// module chunks = 